import React from "react";
import EmpresaProductoProximamente from "../components/empresas/EmpresaProductoProximamente";
import { getProductoProximamente } from "../data/empresasProductosProximamente";

function EmpresasTramitesDigitales() {
  return <EmpresaProductoProximamente config={getProductoProximamente("tramites-digitales")} />;
}

export default EmpresasTramitesDigitales;
